import { useEffect, useRef } from "react";
import { loadCalendly } from "@/lib/calendly";
import { CALENDLY_URL } from "@/data/content";

// Inline scheduler embed
export function CalendlyInline({ url }) {
  const containerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const target = url || CALENDLY_URL;
    loadCalendly()
      .then((Calendly) => {
        const parentElement = containerRef.current;
        if (cancelled || !parentElement) return;
        parentElement.replaceChildren();
        Calendly.initInlineWidget({ url: target, parentElement, resize: true });
      })
      .catch((err) => { if (!cancelled) console.error(err); });
    const node = containerRef.current;
    return () => { cancelled = true; node?.replaceChildren(); };
  }, [url]);

  return (
    <div
      ref={containerRef}
      data-testid="calendly-inline"
      className="w-full rounded-[1.5rem] overflow-hidden"
      style={{ minWidth: "320px", height: "720px" }}
      aria-label="Schedule a session with Cranio Cove"
    />
  );
}

// Open the scheduler in a popup (falls back to opening the URL in a new tab)
export function openCalendlyPopup(url) {
  const target = url || CALENDLY_URL;
  loadCalendly()
    .then((Calendly) => Calendly.initPopupWidget({ url: target }))
    .catch(() => window.open(target, "_blank", "noopener,noreferrer"));
}
